// src/data/languages/bambara/categories/sentencesgap.ts

import { RevisionSentenceCollection } from '../../../../types/types';

// Collection de phrases pour la révision en bambara
export const sentencesgap: RevisionSentenceCollection = {
  // Pronoms personnels au présent progressif
  "n bi": [
    { original: "N bi taa so", french: "Je suis en train d'aller à la maison", english: "I am on my way home" },
    { original: "N bi kalan", french: "Je suis en train d'étudier", english: "I am studying" },
    { original: "N bi jɛ", french: "Je suis en train de manger", english: "I am eating" }
  ],
  "an bi": [
    { original: "An bi kalan", french: "Nous sommes en train d'étudier", english: "We are studying" },
    { original: "An bi taa so", french: "Nous sommes en train d'aller à la maison", english: "We are going home" },
    { original: "An bi nɔgɔ", french: "Nous sommes en train de travailler", english: "We are working" }
  ],
  "i bi": [
    { original: "I bi jɛ", french: "Tu es en train de manger", english: "You are eating" },
    { original: "I bi sigi", french: "Tu es en train de t'asseoir", english: "You are sitting down" },
    { original: "I bi taa marché", french: "Tu es en train d'aller au marché", english: "You are going to the market" }
  ],
  "a bi": [
    { original: "A bi sigi", french: "Il/Elle est en train de s'asseoir", english: "He/She is sitting down" },
    { original: "A bi kalan", french: "Il/Elle est en train d'étudier", english: "He/She is studying" },
    { original: "A bi nɔgɔ", french: "Il/Elle est en train de travailler", english: "He/She is working" }
  ],
  "aw bi": [
    { original: "Aw bi ka fo", french: "Vous êtes en train de parler", english: "You are talking" },
    { original: "Aw bi sigi", french: "Vous êtes en train de vous asseoir", english: "You are sitting down" },
    { original: "Aw bi jɛ", french: "Vous êtes en train de manger", english: "You are eating" }
  ],
  "u bi": [
    { original: "U bi nɔgɔ", french: "Ils/Elles sont en train de travailler", english: "They are working" },
    { original: "U bi sigi", french: "Ils/Elles sont en train de s'asseoir", english: "They are sitting down" },
    { original: "U bi taa so", french: "Ils/Elles sont en train d'aller à la maison", english: "They are going home" }
  ],

  // Pronoms possessifs
  "n ka": [
    { original: "N ka so bɛ nɔgɔ", french: "Ma maison est grande", english: "My house is big" },
    { original: "N ka kalan bɛ jɛgɛ", french: "Mon éducation est importante", english: "My education is important" },
    { original: "N ka den bɛ kɛnɛ", french: "Mon enfant est en bonne santé", english: "My child is healthy" }
  ],
  "i ka": [
    { original: "I ka kɛ bɛ sanji", french: "Ton champ est humide", english: "Your field is wet" },
    { original: "I ka muso bɛ dɔɔrɔman", french: "Ta femme est belle", english: "Your wife is beautiful" },
    { original: "I ka so bɛ tureli", french: "Ta maison est propre", english: "Your house is clean" }
  ],
  "a ka": [
    { original: "A ka mogo bɛ duguma", french: "Son ami est en ville", english: "His/Her friend is in town" },
    { original: "A ka den bɛ dimin", french: "Son enfant est petit", english: "His/Her child is small" },
    { original: "A ka baba bɛ kɔrɔn", french: "Son père est vieux", english: "His/Her father is old" }
  ],
  "an ka": [
    { original: "An ka barika bɛ banjul", french: "Notre chance est grande", english: "Our luck is great" },
    { original: "An ka den bɛ kalan", french: "Notre enfant étudie", english: "Our child is studying" },
    { original: "An ka so bɛ jɛgɛ", french: "Notre maison est grande", english: "Our house is big" }
  ],
  "aw ka": [
    { original: "Aw ka muso bɛ sigida", french: "Votre sœur est assise", english: "Your sister is sitting" },
    { original: "Aw ka den bɛ kɛnɛ", french: "Votre enfant est en bonne santé", english: "Your child is healthy" },
    { original: "Aw ka nɔgɔ bɛ fisa", french: "Votre travail est rapide", english: "Your work is fast" }
  ],
  "u ka": [
    { original: "U ka den bɛ kalan", french: "Leurs enfants étudient", english: "Their children are studying" },
    { original: "U ka so bɛ jɛgɛ", french: "Leur maison est grande", english: "Their house is big" },
    { original: "U ka nɔgɔ bɛ nyuman", french: "Leur travail est bon", english: "Their work is good" }
  ],

  // Pronoms compléments
  "n ye": [
    { original: "A bɛ n ye fɛ", french: "Il/Elle m'aime", english: "He/She loves me" },
    { original: "U bɛ n ye jɛ", french: "Ils/Elles me voient", english: "They see me" },
    { original: "I bɛ n ye kɔrɔ", french: "Tu m'aides", english: "You help me" }
  ],
  "i ye": [
    { original: "N bɛ i ye fɔ", french: "Je te parle", english: "I am talking to you" },
    { original: "A bɛ i ye fɛ", french: "Il/Elle t'aime", english: "He/She loves you" },
    { original: "An bɛ i ye jɛ", french: "Nous te voyons", english: "We see you" }
  ],
  "a ye": [
    { original: "Aw bɛ a ye jɛ", french: "Vous le/la voyez", english: "You see him/her" },
    { original: "N bɛ a ye fɛ", french: "Je l'aime", english: "I love him/her" },
    { original: "An bɛ a ye kɔrɔ", french: "Nous l'aidons", english: "We help him/her" }
  ],

  // Pronoms emphatiques
  "n kɔ": [
    { original: "N kɔ bɛ taa", french: "Moi, je vais", english: "As for me, I'm going" },
    { original: "N kɔ bɛ kalan", french: "Moi, j'étudie", english: "As for me, I study" },
    { original: "N kɔ bɛ nɔgɔ", french: "Moi, je travaille", english: "As for me, I work" }
  ],
  "i kɔ": [
    { original: "I kɔ bɛ kalan", french: "Toi, tu étudies", english: "As for you, you study" },
    { original: "I kɔ bɛ jɛ", french: "Toi, tu manges", english: "As for you, you eat" },
    { original: "I kɔ bɛ taa so", french: "Toi, tu vas à la maison", english: "As for you, you're going home" }
  ],
  "a kɔ": [
    { original: "A kɔ bɛ sɔrɔ", french: "Lui/Elle, il/elle a", english: "As for him/her, he/she has" },
    { original: "A kɔ bɛ nɔgɔ", french: "Lui/Elle, il/elle travaille", english: "As for him/her, he/she works" },
    { original: "A kɔ bɛ kalan", french: "Lui/Elle, il/elle étudie", english: "As for him/her, he/she studies" }
  ],

  // Temps verbaux
  "a bɛ taa": [
    { original: "A bɛ taa so dun", french: "Il/Elle ira à la maison demain", english: "He/She will go home tomorrow" },
    { original: "A bɛ taa kɔrɔ la", french: "Il/Elle ira à l'école", english: "He/She will go to school" },
    { original: "A bɛ taa marché", french: "Il/Elle ira au marché", english: "He/She will go to the market" }
  ],
  "a bɛ jɛ": [
    { original: "A bɛ jɛ mogo", french: "Il/Elle voit quelqu'un", english: "He/She sees someone" },
    { original: "A bɛ jɛ so", french: "Il/Elle voit la maison", english: "He/She sees the house" },
    { original: "A bɛ jɛ den", french: "Il/Elle voit l'enfant", english: "He/She sees the child" }
  ],
  "a bɛ sigi": [
    { original: "A bɛ sigi so", french: "Il/Elle est assis(e) à la maison", english: "He/She is sitting at home" },
    { original: "A bɛ sigi kɔ so", french: "Il/Elle est assis(e) dans la maison", english: "He/She is sitting inside the house" },
    { original: "A bɛ sigi fɛ tabali", french: "Il/Elle est assis(e) près de la table", english: "He/She is sitting near the table" }
  ],
  "a ka taa": [
    { original: "A ka taa marché", french: "Il/Elle est allé(e) au marché", english: "He/She went to the market" },
    { original: "A ka taa so", french: "Il/Elle est allé(e) à la maison", english: "He/She went home" },
    { original: "A ka taa kɔrɔ", french: "Il/Elle est allé(e) à l'école", english: "He/She went to school" }
  ],
  "a tɛ taa": [
    { original: "A tɛ taa so dun", french: "Il/Elle n'ira pas à la maison demain", english: "He/She will not go home tomorrow" },
    { original: "A tɛ taa marché", french: "Il/Elle n'ira pas au marché", english: "He/She will not go to the market" },
    { original: "A tɛ taa kɔrɔ", french: "Il/Elle n'ira pas à l'école", english: "He/She will not go to school" }
  ],

  // Prépositions
  "kɔ": [
    { original: "N bɛ sigi kɔ so", french: "Je suis assis dans la maison", english: "I am sitting inside the house" },
    { original: "A bɛ taa kɔ marché", french: "Il/Elle va au marché", english: "He/She goes to the market" },
    { original: "Den bɛ kɔ kɔrɔ", french: "L'enfant est à l'école", english: "The child is at school" }
  ],
  "fɛ": [
    { original: "A bɛ fɛ n ye", french: "Il/Elle est à côté de moi", english: "He/She is next to me" },
    { original: "Den bɛ fɛ tabali", french: "L'enfant est près de la table", english: "The child is near the table" },
    { original: "N bɛ fɛ kɔrɔ", french: "Je suis près de l'école", english: "I am near the school" }
  ],
  "sɔrɔ": [
    { original: "Musoya bɛ sɔrɔ tabali", french: "La clé est sous la table", english: "The key is under the table" },
    { original: "Balo bɛ sɔrɔ bama", french: "Le livre est sous le lit", english: "The book is under the bed" },
    { original: "Den bɛ sɔrɔ jiri", french: "L'enfant est sous l'arbre", english: "The child is under the tree" }
  ],
  "kan": [
    { original: "A ka bɔ kan tabali", french: "Il/Elle a posé cela sur la table", english: "He/She put it on the table" },
    { original: "Balo bɛ kan tabali", french: "Le livre est sur la table", english: "The book is on the table" },
    { original: "Den bɛ kan bama", french: "L'enfant est sur le lit", english: "The child is on the bed" }
  ],

  // Adjectifs
  "dɔɔrɔman": [
    { original: "A ka muso dɔɔrɔman ye", french: "Sa femme est belle", english: "His wife is beautiful" },
    { original: "Den dɔɔrɔman bɛ kalan", french: "Le bel enfant étudie", english: "The beautiful child is studying" },
    { original: "So dɔɔrɔman bɛ jɛgɛ", french: "La belle maison est grande", english: "The beautiful house is big" }
  ],
  "kɛnɛ": [
    { original: "A ka kɛlɛ kɛnɛ ye", french: "Son corps est en bonne santé", english: "His/Her body is healthy" },
    { original: "Den kɛnɛ bɛ kalan", french: "L'enfant sain étudie", english: "The healthy child is studying" },
    { original: "Muso kɛnɛ bɛ nɔgɔ", french: "La femme en bonne santé travaille", english: "The healthy woman is working" }
  ],
  "jɛgɛ": [
    { original: "N ka so jɛgɛ ye", french: "Ma maison est grande", english: "My house is big" },
    { original: "Mogo jɛgɛ bɛ taa", french: "Le grand homme s'en va", english: "The tall man is leaving" },
    { original: "Jiri jɛgɛ bɛ kɔrɔ so", french: "Le grand arbre est derrière la maison", english: "The big tree is behind the house" }
  ],
  "dimin": [
    { original: "A ka den dimin ye", french: "Son enfant est petit", english: "His/Her child is small" },
    { original: "So dimin bɛ dɔɔrɔman", french: "La petite maison est belle", english: "The small house is beautiful" },
    { original: "Muso dimin bɛ nɔgɔ", french: "La petite femme travaille", english: "The small woman is working" }
  ],
  "kɔrɔn": [
    { original: "A ka baba kɔrɔn ye", french: "Son père est vieux", english: "His/Her father is old" },
    { original: "Muso kɔrɔn bɛ sigi", french: "La vieille femme est assise", english: "The old woman is sitting" },
    { original: "Cɛ kɔrɔn bɛ nɔgɔ", french: "Le vieil homme travaille", english: "The old man is working" }
  ],
  "nyuman": [
    { original: "A ka kalan nyuman ye", french: "Son éducation est bonne", english: "His/Her education is good" },
    { original: "Den nyuman bɛ kalan", french: "Le bon enfant étudie", english: "The good child is studying" },
    { original: "Nɔgɔ nyuman bɛ dɛmɛ", french: "Le bon travail est utile", english: "Good work is useful" }
  ],
  "fon": [
    { original: "A ka nɔgɔ fon ye", french: "Son travail est mauvais", english: "His/Her work is bad" },
    { original: "Mogo fon bɛ taa", french: "La mauvaise personne s'en va", english: "The bad person is leaving" },
    { original: "Kalan fon bɛ gɛrɛ", french: "La mauvaise éducation est difficile", english: "Bad education is difficult" }
  ]
};

export default sentencesgap;
export {};
